module.exports = __webpack_public_path__ + "static/media/14.993f6cf6.jpg";